module.exports = __webpack_public_path__ + "img/file-img.df705a7c.svg";